import React, { useState } from 'react';
import { Modal } from '../../admin/Modal';
import { AlertTriangle } from 'lucide-react';

interface ConfirmCoachedModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (assignToMe: boolean) => void;
  clientName: string;
}

export const ConfirmCoachedModeModal: React.FC<ConfirmCoachedModeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  clientName
}) => {
  const [assignToMe, setAssignToMe] = useState(false);

  const handleConfirm = () => {
    onConfirm(assignToMe);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Switch to Coached Mode?"
      variant="warning"
      size="small"
      footer={
        <>
          <button className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleConfirm}>
            Confirm
          </button>
        </>
      }
    >
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
          <AlertTriangle size={20} color="var(--warning)" />
          <span style={{ fontWeight: '600', color: 'var(--text-primary)' }}>
            This will change how {clientName} interacts with goals
          </span>
        </div>

        <div style={{ marginLeft: '28px', color: 'var(--text-secondary)', fontSize: '14px' }}>
          <p style={{ margin: '8px 0' }}>This will:</p>
          <ul style={{ margin: '8px 0', paddingLeft: '20px' }}>
            <li>Make goals read-only for the client</li>
            <li>Allow you to manage their goals</li>
          </ul>
        </div>
      </div>

      <div style={{ padding: '12px', backgroundColor: 'var(--bg-secondary)', borderRadius: '8px', border: '1px solid var(--border)' }}>
        <label style={{ display: 'flex', alignItems: 'flex-start', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={assignToMe}
            onChange={(e) => setAssignToMe(e.target.checked)}
            style={{ marginRight: '12px', marginTop: '2px' }}
          />
          <span style={{ fontSize: '14px', color: 'var(--text-primary)' }}>
            Assign this client to me
          </span>
        </label>
      </div>
    </Modal>
  );
};
